import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authBusiness } from "../../api/bussiness/auth/auth-business";

export const OAuthRedirect = observer(() => {
  const {
    authentication: { setProp },
  } = useStores();

  const navigate = useNavigate();

  // rerendering the components does not change isProcessed, but remounting the component does change.
  const isProcessed = useRef(false);

  useEffect(() => {
    async function processOAuthResponse() {
      // this is needed, because React.StrictMode makes component to rerender
      // second time the auth code that is in req.url here is invalid,
      // so we want it to execute one time only.
      if (isProcessed.current) {
        return;
      }

      isProcessed.current = true;

      try {
        const currentUrl = window.location.href;
        await authBusiness.handleOAuthCallback(currentUrl);
        const isAuthenticated = await authBusiness.isAuthenticated();

        setProp("isAuthenticated", isAuthenticated);
        navigate("/", { replace: true });
      } catch (error) {
        console.error("Error processing OAuth callback:", error);
      }
    }

    processOAuthResponse();
  }, [navigate, setProp]);

  return <></>;
});
